import React, { useEffect, useState } from "react";
import { Testimonial } from "../admin/interfaces/Testimonial";
import { testimonialService } from "../admin/services/testimonialService";

const TestimonialSection: React.FC = () => {

  const API_PATH = process.env.REACT_APP_API_PATH;

  const [testimonials, setTestimonials] =
    useState<Testimonial[]>([]);

  const [cur, setCur] =
    useState<number>(0);

  const [loading, setLoading] = useState<boolean>(true);

  // =========================================
  // FETCH TESTIMONIALS
  // =========================================
  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const data =
        await testimonialService.GetClientTestimonials();

      setTestimonials(data);

    } catch (error) {

      console.error(
        "Error fetching testimonials:",
        error
      );

    } finally {
      setLoading(false);
    }
  };

  // =========================================
  // SLIDER FUNCTIONS
  // =========================================
  const prev = () => {
    setCur(
      (c) => (c - 1 + testimonials.length) % testimonials.length);
  };

  const next = () => {

    setCur(
      (c) => (c + 1) % testimonials.length);
  };

  // =========================================
  // LOADING
  // =========================================
  if (loading) {

    return (
      <p>
        Loading testimonials...
      </p>
    );
  }

  // =========================================
  // NO DATA
  // =========================================
  if (testimonials.length === 0) {

    return (
      <p>
        No testimonials found.
      </p>
    );
  }

  const currentTestimonial =
    testimonials[cur];

  return (

    <section
      className="testi-layout1 space z-index-common overflow-hidden"
      style={{
        backgroundImage:
          "url('/assets/img/testimonials/testi-bg-1-1.png')",
          backgroundPosition:"center"
      }}
    >

      <div
        className="img-box3 testimonial-image"
        style={{
          backgroundImage:
            "url('/assets/img/testimonials/testi-1-1.jpg')"
        }}
      ></div>

      <img
        src="/assets/img/testimonials/testi-shape-1-1.svg"
        alt="testi shape"
        className="ele1"
      />

      <div className="container">

        <div className="row justify-content-end">

          <div className="col-lg-7">

            <div className="title-area text-center">

              <span className="sec-subtitle">
                CLIENT TESTIMONIALS
              </span>

              <h2 className="sec-title">
                Our Happy Clients
              </h2>

              <img
                src="/assets/img/shapes/title-shape-2.svg"
                alt="title shape"
              />

            </div>

            <div className="testi-inner z-index-common">

              <div className="vs-carousel-arrow">

                <button onClick={prev}>
                  <svg width="20" height="14" viewBox="0 0 20 14" fill="none">
                    <path d="M7.57 0.930054L1.5 7.00005L7.57 13.0701" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M18.4999 7H1.66992" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>

                <button onClick={next}>
                  <svg width="20" height="14" viewBox="0 0 20 14" fill="none">
                    <path d="M12.4299 0.930054L18.4999 7.00005L12.4299 13.0701" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M1.5 7H18.33" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>

              </div>

              <div className="testi-style">

                <div className="testi-thumb">

                  <img
                    className="img-home-testimonial"
                    src={`${API_PATH}/TestimonialImages/${currentTestimonial.customerImage}`}
                  />

                </div>

                <p className="testi-text">
                  {currentTestimonial.review}
                </p>

                <span className="testi-user">
                  {currentTestimonial.customerName}
                </span>

              </div>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default TestimonialSection;